import { IUserTypes } from './interface'

export const USER_TYPES: IUserTypes = {
  adOpsAdmin: 'AdOpsAdministrator',
  adOpsCommercialSuccessOperator: 'AdOpsCommercialSuccessOperator',
  adOpsCustomerSupport: 'AdOpsCustomerSupport',
  adOpsReadOnly: 'AdOpsReadOnly',
  adOpsAccountExecutive: 'AdOpsAccountExecutive',
  merchant: 'Merchant'
}
